import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["id", "checked", "onChange"]
const _hoisted_2 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("ul", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.available, (option, index) => {
      return (_openBlock(), _createElementBlock("li", { key: index }, [
        _createElementVNode("input", {
          type: "checkbox",
          id: _ctx.compId + index,
          checked: _ctx.checked(option.value),
          onChange: ($event: any) => (_ctx.onChange($event.target.checked, option.value))
        }, null, 40, _hoisted_1),
        _createElementVNode("label", {
          for: _ctx.compId + index
        }, _toDisplayString(option.label), 9, _hoisted_2)
      ]))
    }), 128))
  ]))
}